@if (emissionDetail) {
  <nb-card>
    <nb-card-body>
      <div class="header">
        <h1 class="title">
          {{ emissionDetail.name }}
          @if (energyTypeName) {
            ({{energyTypeName}})
          }
        </h1>
        <div class="top-buttons">
          <span (click)="downloadProvider()">
            <fa-icon [icon]="['fat', 'cloud-arrow-down']"></fa-icon>
          </span>
          <span class="close-button" (click)="closeRef()">
            <fa-icon icon="xmark"></fa-icon>
          </span>
        </div>
      </div>
      <nb-tabset fullWidth (changeTab)="changeTab()">
        <nb-tab
          [tabTitle]="'Emission factor' | translate"
          [active]="defaultSelectedTab === 'emissionFactor' && emissionFactorByCountryAndYear?.length"
          class="pt-5"
          >
          <app-ag-grid-emission-factors [emissionFactorByCountryAndYear]="emissionFactorByCountryAndYear"
            [emissionFactorByYear]="emissionFactorByYear"
            [based]="emissionDetail.based"
            [energyTypeId]="energyId"
            [providerId]="providerId"
          ></app-ag-grid-emission-factors>
        </nb-tab>
        <nb-tab [tabTitle]="'About' | translate" [active]="defaultSelectedTab === 'synthesis'">
          <div class="synthesis pt-2">
            <div class="desc" [innerHTML]="emissionDetail.synthese"></div>
            <div class="link">
              {{ "HTML Link" | translate }}
            </div>
          </div>
        </nb-tab>
      </nb-tabset>
    </nb-card-body>
  </nb-card>
}
